import { Injectable } from '@angular/core';

@Injectable()
export class PunchoutService {
  private _punchoutMessageId:number;

  public setPunchoutMessageId(id:string):void {
    this._punchoutMessageId = parseInt(id);
  }

  public getPunchoutMessageId():number {
    return this._punchoutMessageId;
  }

  public clear():void {
    this._punchoutMessageId = undefined;
  }
}